<template>
  <div>
    <div style="position: absolute; width: 100%; height: 100%; min-height: 50em; min-width: 50em" ref="map"></div>
    <section style="position: absolute; width: 100%; height: 100%; pointer-events: none;" class="section is-main-section">
      <div style="position: relative;" class="columns">
        <div style="pointer-events: all;" class="column is-one-third">
          <card-component>
            <div class="block">
              <b-field grouped group-multiline>
                <b-field label="From Date">
                  <b-datepicker
                      v-model="fromDate"
                      :locale="lang"
                      placeholder="Show Data from Date"
                      icon="calendar-today"
                      trap-focus>
                  </b-datepicker>
                </b-field>
                <b-field label="to Date">
                  <b-datepicker
                      v-model="toDate"
                      :locale="lang"
                      placeholder="Show Data from Date"
                      icon="calendar-today"
                      trap-focus>
                  </b-datepicker>
                </b-field>
              </b-field>
            </div>
            <div class="block">
              <b-field>
                <b-radio-button v-model="resultLocation"
                    native-value="radsatz"
                    type="is-outlined is-light is-primary">
                    Radsatz
                </b-radio-button>
                <b-radio-button v-model="resultLocation"
                    native-value="drehgestell"
                    type="is-outlined is-light is-primary">
                    Drehgestell
                </b-radio-button>
                <b-radio-button v-model="resultLocation"
                    native-value="wagenkasten"
                    type="is-outlined is-light is-primary">
                    Wagenkasten
                </b-radio-button>
                <b-radio-button v-model="resultLocation"
                    native-value="sound"
                    type="is-outlined is-light is-primary">
                    Sound A-Weighted
                </b-radio-button>
                <b-radio-button v-model="resultLocation"
                    native-value="sound_5300"
                    type="is-outlined is-light is-primary">
                    Squeal
                </b-radio-button>
                <b-icon size="is-large" custom-class="mdi-spin" icon="loading" v-show="mapIsLoading"></b-icon>
              </b-field>

            </div>
        </card-component>
        <card-component>
          <b translate="no">Name: {{routeName}}</b>
          <p translate="no"><b-icon icon="ruler"></b-icon>KM from {{startKM}} to {{endKM}}</p>
          <p translate="no"><b-icon icon="ruler-square-compass"></b-icon>Radius Start {{startRadius}} to {{endRadius}}</p>
          <p translate="no">{{routeNameShow}}</p>
        </card-component>
           <card-component>
          <div style="height: 15em;" ref="radiusplot"></div>
        </card-component>

      </div>

      </div>
    </section>
  </div>
</template>
<style>
  canvas {
    outline: none;
  }
</style>
<script>
import CardComponent from '@/components/CardComponent'
import Plotly from 'plotly.js-dist'
import maplibre from 'maplibre-gl'
import { api } from '@/main.js'
import store from '@/store'
require('maplibre-gl/dist/maplibre-gl.css')

export default {
  name: 'routes',
  components: {
    CardComponent
  },
  mounted () {
    this.map = new maplibre.Map({
      container: this.$refs['map'],
      style: 'https://static.tcnd.app/map/style_rail.json',
      minZoom: 10,
      hash: true,
      transformRequest: (url, resourceType) => {
        if (resourceType === 'Tile' && url.match(window.location.origin)) {
          return {
            url: url,
            headers: {
              Authorization: 'Bearer ' + store.state.userToken
            }
          }
        }
      }
    })
    this.map.addControl(new maplibre.NavigationControl())
    this.map.addControl(new maplibre.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: true
    }))
    this.map.on('load', () => {
      this.addSourceAndLayer()
    })
    this.map.on('data', () => {
      this.mapIsLoading = true
    })
    this.map.on('idle', () => {
      this.mapIsLoading = false
    })

    let eClick = (e) => {
      this.routeNameShow = e.features[0].properties.name
      if (e.features[0].properties.start_km < e.features[0].properties.end_km) {
        this.showRange = [e.features[0].properties.start_km, e.features[0].properties.end_km]
      } else {
        this.showRange = [e.features[0].properties.end_km, e.features[0].properties.start_km]
      }
    }

    let eMouse = (e) => {
      // this.map.getCanvas().style.cursor = 'pointer'
      this.startRadius = e.features[0].properties.start_radius
      this.endRadius = e.features[0].properties.end_radius
      this.startKM = e.features[0].properties.start_km
      this.endKM = e.features[0].properties.end_km
      this.routeName = e.features[0].properties.name
    }

    this.map.on('click', 'wagenkasten', eClick)
    this.map.on('click', 'drehgestell', eClick)
    this.map.on('click', 'radsatz_left', eClick)
    this.map.on('click', 'radsatz_right', eClick)
    this.map.on('click', 'sound_rechts', eClick)
    this.map.on('click', 'sound_links', eClick)

    this.map.on('mousemove', 'rail1', eMouse)
    this.map.on('mousemove', 'drehgestell', eMouse)
    this.map.on('mousemove', 'radsatz_left', eMouse)
    this.map.on('mousemove', 'radsatz_right', eMouse)
    this.map.on('mousemove', 'sound_links', eMouse)
    this.map.on('mousemove', 'sound_rechts', eMouse)

    this.plot = Plotly.newPlot(
      this.$refs['radiusplot'],
      [],
      {
        margin: { // update the left, bottom, right, top margin
          l: 40,
          b: 40,
          r: 0,
          t: 40
        }
      },
      { doubleClick: false, scrollZoom: true, responsive: true, displaylogo: false, modeBarButtonsToRemove: ['toImage'] }
    )
    Plotly.addTraces(this.$refs['radiusplot'],
      [
        {
          x: [],
          y: [],
          line: { width: 1 },
          type: 'scatter',
          hoverinfo: 'none',
          showlegend: false,
          connectgaps: false
        }
      ]
    )
    this.resultLocation = 'radsatz'
    /*
    this.map.on('mouseleave', 'lines', (e) => {
      this.map.getCanvas().style.cursor = ''
      this.startRadius = null
      this.endRadius = null
      this.startKM = null
      this.endKM = null
      this.routeName = null
    })
    */
  },
  data () {
    var today = new Date()
    var previous = new Date(today - (14 * 24 * 3600 * 1000))

    return {
      startRadius: null,
      endRadius: null,
      startKM: null,
      endKM: null,
      length: null,
      routeName: null,
      routeNameShow: null,
      radiusData: null,
      plot: null,
      // showWagenkasten: true,
      // showRadsatzlager: true,
      toDate: today,
      fromDate: previous,
      showRange: [],
      lang: navigator.language,
      mapIsLoading: false,
      resultLocation: 'radsatz'
    }
  },
  watch: {
    routeNameShow: function (newLine, oldLine) {
      api.get('geo/routes/line/' + newLine + '/geo')
        .then((resp) => {
          console.log()
          this.plot = Plotly.newPlot(
            this.$refs['radiusplot'],
            [{ x: resp.data.x, y: resp.data.y, connectgaps: false, line: { width: 3 }, mode: 'lines', type: 'scatter' }],
            { title: { text: newLine }, xaxis: { title: { text: 'Kilometer [m]' } }, yaxis: { title: { text: 'Kurve [1/m]' } } },
            { doubleClick: false, scrollZoom: true, responsive: true, displaylogo: false, modeBarButtonsToRemove: ['toImage'] }
          )
          this.setRangeHighlightPlot(this.showRange)
        })
    },
    showRange: function (newVal, oldVal) {
      this.setRangeHighlightPlot(newVal)
    },
    resultLocation: function (newValue, oldValue) {
      this.map.setLayoutProperty('wagenkasten', 'visibility', 'none')
      this.map.setLayoutProperty('drehgestell', 'visibility', 'none')
      this.map.setLayoutProperty('radsatz_left', 'visibility', 'none')
      this.map.setLayoutProperty('radsatz_right', 'visibility', 'none')
      this.map.setLayoutProperty('sound_rechts', 'visibility', 'none')
      this.map.setLayoutProperty('sound_links', 'visibility', 'none')
      this.map.setLayoutProperty('sound_rechts_5300', 'visibility', 'none')
      this.map.setLayoutProperty('sound_links_5300', 'visibility', 'none')
      switch (newValue) {
        case 'wagenkasten':
          this.map.setLayoutProperty('wagenkasten', 'visibility', 'visible')
          break
        case 'drehgestell':
          this.map.setLayoutProperty('drehgestell', 'visibility', 'visible')
          break
        case 'radsatz':
          this.map.setLayoutProperty('radsatz_left', 'visibility', 'visible')
          this.map.setLayoutProperty('radsatz_right', 'visibility', 'visible')
          break
        case 'sound':
          this.map.setLayoutProperty('sound_rechts', 'visibility', 'visible')
          this.map.setLayoutProperty('sound_links', 'visibility', 'visible')
          break
        case 'sound_5300':
          this.map.setLayoutProperty('sound_rechts_5300', 'visibility', 'visible')
          this.map.setLayoutProperty('sound_links_5300', 'visibility', 'visible')
          break
        default:
          break
      }
    },
    fromDate: function (newValue, oldValue) {
      this.removeSourceAndLayer()
      this.addSourceAndLayer()
    },
    toDate: function (newValue, oldValue) {
      this.removeSourceAndLayer()
      this.addSourceAndLayer()
    }
  },
  methods: {
    setRangeHighlightPlot: function (range) {
      var diff = (range[1] - range[0]) * 2
      if (diff < 500) {
        diff = 500
      }
      var update = {
        'xaxis.range': [range[0] - 2 * diff, range[1] + 2 * diff],
        'shapes': [{
          type: 'rect',
          xref: 'x',
          yref: 'paper',
          x0: range[0],
          y0: 0,
          x1: range[1],
          y1: 1,
          fillcolor: '#ff0000',
          opacity: 0.2,
          line: { width: 0 }
        }],
        margin: { // update the left, bottom, right, top margin
          l: 40,
          b: 40,
          r: 0,
          t: 40
        }
      }
      Plotly.relayout(this.$refs['radiusplot'], update)
    },
    removeSourceAndLayer: function () {
      this.map.removeLayer('wagenkasten')
      this.map.removeLayer('drehgestell')
      this.map.removeLayer('radsatz_left')
      this.map.removeLayer('radsatz_right')
      this.map.removeLayer('sound_rechts')
      this.map.removeLayer('sound_links')
      this.map.removeLayer('sound_rechts_5300')
      this.map.removeLayer('sound_links_5300')
      this.map.removeLayer('rail_text_km')
      this.map.removeLayer('rail_text')
      this.map.removeSource('geos')
    },
    addSourceAndLayer: function () {
      var fromStr = this.fromDate.toISOString().split('T')[0]
      var toStr = this.toDate.toISOString().split('T')[0]
      this.map.addSource('geos', { type: 'vector', tiles: [window.location.origin + '/api/geo/data/parts2/' + fromStr + '/' + toStr + '/{z}/{x}/{y}'], maxzoom: 14, lineMetrics: true })
      this.map.style.addLayer({
        minzoom: 10,
        id: 'wagenkasten',
        layout: {
          visibility: 'none'
        },
        type: 'line',
        source: 'geos',
        'source-layer': 'mvtgeom',
        paint: {
          // 'line-color': 'red',
          // 'line-color': ['match', ['get', 'type'], 'C', '#ff9900', 'D', '#d68000', 'R', '#e88b00', '#000000'],
          // 'line-color': ['interpolate', ['linear'], ['get', 'radius'], -1000, 'green', -200, 'orange', -10, 'red', 0, 'grey', 10, 'red', 200, 'orange', 1000, 'green'],
          'line-color': ['interpolate', ['linear'], ['get', 'wagenkasten'], -1, 'rgba(0,0,0,0)', 0, 'green', 100, 'orange', 200, 'red', 1000, 'purple'],
          'line-width': 5
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 0.0001, 'green', 0.003, 'orange', 0.01, 'red', 1, 'purple' ]
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 10, 'purple' ]
        }
      })
      this.map.style.addLayer({
        minzoom: 10,
        id: 'drehgestell',
        layout: {
          visibility: 'none'
        },
        type: 'line',
        source: 'geos',
        'source-layer': 'mvtgeom',
        paint: {
          // 'line-color': 'red',
          // 'line-color': ['match', ['get', 'type'], 'C', '#ff9900', 'D', '#d68000', 'R', '#e88b00', '#000000'],
          // 'line-color': ['interpolate', ['linear'], ['get', 'radius'], -1000, 'green', -200, 'orange', -10, 'red', 0, 'grey', 10, 'red', 200, 'orange', 1000, 'green'],
          'line-color': ['interpolate', ['linear'], ['get', 'drehgestell'], -1, 'rgba(0,0,0,0)', 0, 'green', 5000, 'orange', 10000, 'red', 20000, 'purple'],
          'line-width': 5
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 0.0001, 'green', 0.003, 'orange', 0.01, 'red', 1, 'purple' ]
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 10, 'purple' ]
        }
      })
      this.map.style.addLayer({
        minzoom: 10,
        id: 'radsatz_left',
        layout: {
          visibility: 'visible'
        },
        type: 'line',
        source: 'geos',
        'source-layer': 'mvtgeom',
        paint: {
          // 'line-color': 'red',
          // 'line-color': ['match', ['get', 'type'], 'C', '#ff9900', 'D', '#d68000', 'R', '#e88b00', '#000000'],
          // 'line-color': ['interpolate', ['linear'], ['get', 'radius'], -1000, 'green', -200, 'orange', -10, 'red', 0, 'grey', 10, 'red', 200, 'orange', 1000, 'green'],
          'line-color': ['interpolate', ['linear'], ['get', 'radsatzlinks'], -1, 'rgba(0,0,0,0)', 0, 'green', 100000, 'orange', 200000, 'red', 1000000, 'purple'],
          'line-width': 5,
          'line-offset': -2.5
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 0.0001, 'green', 0.003, 'orange', 0.01, 'red', 1, 'purple' ]
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 10, 'purple' ]
        }
      })
      this.map.style.addLayer({
        minzoom: 10,
        id: 'radsatz_right',
        layout: {
          visibility: 'visible'
        },
        type: 'line',
        source: 'geos',
        'source-layer': 'mvtgeom',
        paint: {
          // 'line-color': 'red',
          // 'line-color': ['match', ['get', 'type'], 'C', '#ff9900', 'D', '#d68000', 'R', '#e88b00', '#000000'],
          // 'line-color': ['interpolate', ['linear'], ['get', 'radius'], -1000, 'green', -200, 'orange', -10, 'red', 0, 'grey', 10, 'red', 200, 'orange', 1000, 'green'],
          'line-color': ['interpolate', ['linear'], ['get', 'radsatzrechts'], -1, 'rgba(0,0,0,0)', 0, 'green', 100000, 'orange', 200000, 'red', 1000000, 'purple'],
          'line-width': 5,
          'line-offset': 2.5
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 0.0001, 'green', 0.003, 'orange', 0.01, 'red', 1, 'purple' ]
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 10, 'purple' ]
        }
      })
      this.map.style.addLayer({
        minzoom: 10,
        id: 'sound_links',
        layout: {
          visibility: 'none'
        },
        type: 'line',
        source: 'geos',
        'source-layer': 'mvtgeom',
        paint: {
          // 'line-color': 'red',
          // 'line-color': ['match', ['get', 'type'], 'C', '#ff9900', 'D', '#d68000', 'R', '#e88b00', '#000000'],
          // 'line-color': ['interpolate', ['linear'], ['get', 'radius'], -1000, 'green', -200, 'orange', -10, 'red', 0, 'grey', 10, 'red', 200, 'orange', 1000, 'green'],
          'line-color': ['interpolate', ['linear'], ['get', 'sound_links'], -1, 'rgba(0,0,0,0)', 35, 'green', 38, 'orange', 40, 'red', 45, 'purple'],
          'line-width': 5,
          'line-offset': -2.5
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 0.0001, 'green', 0.003, 'orange', 0.01, 'red', 1, 'purple' ]
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 10, 'purple' ]
        }
      })
      this.map.style.addLayer({
        minzoom: 10,
        id: 'sound_rechts',
        layout: {
          visibility: 'none'
        },
        type: 'line',
        source: 'geos',
        'source-layer': 'mvtgeom',
        paint: {
          // 'line-color': 'red',
          // 'line-color': ['match', ['get', 'type'], 'C', '#ff9900', 'D', '#d68000', 'R', '#e88b00', '#000000'],
          // 'line-color': ['interpolate', ['linear'], ['get', 'radius'], -1000, 'green', -200, 'orange', -10, 'red', 0, 'grey', 10, 'red', 200, 'orange', 1000, 'green'],
          'line-color': ['interpolate', ['linear'], ['get', 'sound_rechts'], -1, 'rgba(0,0,0,0)', 35, 'green', 38, 'orange', 40, 'red', 45, 'purple'],
          'line-width': 5,
          'line-offset': 2.5
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 0.0001, 'green', 0.003, 'orange', 0.01, 'red', 1, 'purple' ]
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 10, 'purple' ]
        }
      })
      this.map.style.addLayer({
        minzoom: 10,
        id: 'sound_links_5300',
        layout: {
          visibility: 'none'
        },
        type: 'line',
        source: 'geos',
        'source-layer': 'mvtgeom',
        paint: {
          // 'line-color': 'red',
          // 'line-color': ['match', ['get', 'type'], 'C', '#ff9900', 'D', '#d68000', 'R', '#e88b00', '#000000'],
          // 'line-color': ['interpolate', ['linear'], ['get', 'radius'], -1000, 'green', -200, 'orange', -10, 'red', 0, 'grey', 10, 'red', 200, 'orange', 1000, 'green'],
          'line-color': ['interpolate', ['linear'], ['get', 'sound_links_5300'], -1, 'rgba(0,0,0,0)', 0, 'green', 2, 'orange', 3, 'red', 4, 'purple'],
          'line-width': 5,
          'line-offset': -2.5
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 0.0001, 'green', 0.003, 'orange', 0.01, 'red', 1, 'purple' ]
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 10, 'purple' ]
        }
      })
      this.map.style.addLayer({
        minzoom: 10,
        id: 'sound_rechts_5300',
        layout: {
          visibility: 'none'
        },
        type: 'line',
        source: 'geos',
        'source-layer': 'mvtgeom',
        paint: {
          // 'line-color': 'red',
          // 'line-color': ['match', ['get', 'type'], 'C', '#ff9900', 'D', '#d68000', 'R', '#e88b00', '#000000'],
          // 'line-color': ['interpolate', ['linear'], ['get', 'radius'], -1000, 'green', -200, 'orange', -10, 'red', 0, 'grey', 10, 'red', 200, 'orange', 1000, 'green'],
          'line-color': ['interpolate', ['linear'], ['get', 'sound_rechts_5300'], -1, 'rgba(0,0,0,0)', 0, 'green', 2, 'orange', 3, 'red', 4, 'purple'],
          'line-width': 5,
          'line-offset': 2.5
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 0.0001, 'green', 0.003, 'orange', 0.01, 'red', 1, 'purple' ]
          // 'line-gradient': [ 'interpolate', ['linear'], ['line-progress'], 0, 'gray', 10, 'purple' ]
        }
      })
      this.map.addLayer({
        id: 'rail_text',
        minzoom: 10,
        type: 'symbol',
        source: 'geos',
        'source-layer': 'mvtgeom',
        layout: {
          'symbol-placement': 'line-center',
          'text-field': '{type}: {radius}',
          'text-font': ['Noto Sans Regular'],
          'text-size': 12,
          'text-anchor': 'bottom'
        },
        paint: {
          'text-halo-color': 'rgb(255,239,221)',
          'text-halo-width': 3,
          'text-color': 'rgb(0,0,0)'
        }
      })
      this.map.addLayer({
        id: 'rail_text_km',
        minzoom: 10,
        type: 'symbol',
        source: 'geos',
        'source-layer': 'mvtgeom',
        layout: {
          'symbol-placement': 'point',
          'text-field': '{end_km} m',
          'text-padding': 50,
          'text-font': ['Noto Sans Regular'],
          'text-size': 12,
          'text-anchor': 'right'
        },
        paint: {
          'text-halo-color': 'rgb(255,239,221)',
          'text-halo-width': 3,
          'text-color': 'rgb(0,0,0)'
        }
      })
    }
  }
}

</script>
